import { ErrorMessage, Field, useFormikContext } from "formik";
import { useIntl } from "react-intl";
import { cities, typeContract } from "../../../__mocks__/data";
import './applicant-info.scss';
import ParseNumberSmaller from "../../shared/Utilities/ParseNumberSmaller";
import { JSXElementConstructor, ReactElement, ReactFragment, ReactPortal, useEffect, useState } from "react";
import _ from "lodash";
import { AdminService } from "../../../services";
import toast from "react-hot-toast";
import { useRequestContext } from "../../../hooks/useRequestContext";


interface FormPersonalInfoActivityProps {
    errors?: any;
    values?: any;
}

export function FormPersonalInfoActivity(props: FormPersonalInfoActivityProps) {
    const { errors, values } = props;
    const intl = useIntl();
    const [one] = useState(null);
    const [allCities, setAllCiudades] = useState(cities as any);
    const [ciudades, setCiudades] = useState(cities as any);
    const [TipoContrato, setAllTipoContrato] = useState([] as any);
    useEffect(() => {
        allData()
        AdminService.getAllCiudades().then((Datos: any) => {
            setAllCiudades(Datos.payload.data)
        })
    }, [one]
    )
    const { setFieldValue } = useFormikContext<any>();
    const { request } = useRequestContext();

    const allData = async () => {
        const tipocon = await AdminService.getTipoContrato();
        if (tipocon.payload.data.listTipoContr.Datos_TipoContrato.length > 0 &&
            parseInt(tipocon.payload.data.listTipoContr.Datos_TipoContrato[0].s_codigo) > 0) {
            setAllTipoContrato(tipocon.payload.data.listTipoContr.Datos_TipoContrato)
        } else {
            let tipContrato = [
                { s_codigo: "1", s_descripcion: "INDEFINIDO" },
                { s_codigo: "2", s_descripcion: "TERMINO FIJO" },
                { s_codigo: "3", s_descripcion: "N/A" },
                { s_codigo: "4", s_descripcion: "OBRA O LABOR" },
                { s_codigo: "5", s_descripcion: "TEMPORAL" }
            ]
            setAllTipoContrato(tipContrato)
        }
    }

    useEffect(() => {
        if (request && request.personCygnus) {
            const cygnus = request.personCygnus;
            const laborFields = {
                Pws_Nom_empre: cygnus.Pws_Nom_empre,
                Pws_fec_ingemp: cygnus.Pws_fec_ingemp ? cygnus.Pws_fec_ingemp.split("-00")[0] : '',
                Pws_Tip_contra: cygnus.Pws_Tip_contra,
                Pws_Ant_labo: cygnus.Pws_Ant_labo,
                Pws_Car_emp: cygnus.Pws_Car_emp,
                Pws_Nom_Jefedi: cygnus.Pws_Nom_Jefedi,
                Pws_Direc_emp: cygnus.Pws_Direc_emp,
                Pws_Ciud_emp: cygnus.Pws_Ciud_emp,
                Pws_tel_emp1: cygnus.Pws_tel_emp1,
                Pws_tel_emp2: cygnus.Pws_tel_emp2
            };

            Object.entries(laborFields).forEach(([field, value]) => {
                if (value !== undefined && value !== null) {
                    setFieldValue(field, value);
                }
            });
        }
    }, [request]);

    useEffect(() => {
        if (allCities) {

            let citiesDepent = {
                "ListCiudad": {
                    "Datos_Ciudad": [] as any
                }
            }
            citiesDepent.ListCiudad.Datos_Ciudad = _.filter(allCities.ListCiudad.Datos_Ciudad, { s_nivel: '3' });
            setCiudades(citiesDepent)
        }
    }, [allCities])
    const cambios = (evento: any) => {
        const inputValue = evento.target.value;
        const dateStart = new Date(inputValue);
        const dateEnd = new Date();

        if (isNaN(dateStart.getTime())) {
            toast("La fecha ingresada no es válida");
            return;
        }

        if (dateStart > dateEnd) {
            toast("La fecha de ingreso no debe ser mayor a la fecha actual");
            return;
        }

        let years = dateEnd.getFullYear() - dateStart.getFullYear();

        const monthDiff = dateEnd.getMonth() - dateStart.getMonth();
        const dayDiff = dateEnd.getDate() - dateStart.getDate();

        // Si aún no ha cumplido el año completo, restamos uno
        if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
            years--;
        }

        const antiguedad = years >= 0 ? years : 0;
        setFieldValue('Pws_Ant_labo', antiguedad);
    };

    const handleOnlyNumbers = (evento: any) => {
        const { name, value } = evento.target;
        if (/^\d*$/.test(value)) {
            setFieldValue(name, value);
        }
    };
    return (
        <div className="row container-border-app">
            <div className="row" >
                <div className="text-left">

                    <div className="col" style={{ "textAlign": "left" }}>
                        <h3 >Información Laboral</h3>

                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <div
                        className={"label-fields-peps-mobile display-flex"}>{intl.formatMessage({ id: "placeholder_company_name" })}</div>
                    <div className="display-flex">
                        <Field id={"Pws_Nom_empre"}
                            name={"Pws_Nom_empre"}
                            className={`${errors.Pws_Nom_empre ? 'form-know-you-item-input-smaller display-flex input-error' : 'form-know-you-item-input-smaller display-flex'}`}
                            placeholder={intl.formatMessage({ id: "placeholder_company_name" })} />
                    </div>
                </div>
                <div className="col">
                    <div
                        className={"label-fields-peps-mobile display-flex"}>{intl.formatMessage({ id: "placeholder_date_of_admission" })}</div>
                    <div className="display-flex">
                        <Field id={"Pws_fec_ingemp"}
                            name={"Pws_fec_ingemp"}
                            type={"date"}
                            onBlur={cambios}
                            placeholder={'MM/dd/YYYY'}
                            className={`${errors.Pws_fec_ingemp ? 'form-know-you-item-input-smaller display-flex input-error' : 'form-know-you-item-input-smaller display-flex'}`} />
                        {/* <div className="label-fields-peps-warning">
                            <ErrorMessage name="Pws_fec_ingemp"/>
                        </div> */}
                    </div>
                </div>
                <div className="col">
                    <div
                        className={"label-fields-peps-mobile display-flex"}>{intl.formatMessage({ id: "placeholder_type_of_contract" })}</div>
                    <div className="display-flex">
                        <Field as="select"
                            className={`${errors.Pws_Tip_contra ? 'form-know-you-item-input-smaller display-flex input-error' : 'form-know-you-item-input-smaller display-flex'}`}
                            name="Pws_Tip_contra">
                            <option>{intl.formatMessage({ id: "placeholder_type_of_contract" })}</option>
                            {TipoContrato && TipoContrato.map((item: any, key: number) => {
                                return (
                                    <option key={key} value={item.s_codigo}>{item.s_descripcion}</option>
                                )
                            })}
                        </Field>
                    </div>
                </div>
                <div className="col">
                    <div
                        className={"label-fields-peps-mobile display-flex"}>{intl.formatMessage({ id: "placeholder_labor_old" })}</div>
                    <div className="display-flex">
                        {/*   <Field id={"Pws_Ant_labo"}
                               name={"Pws_Ant_labo"}
                               component={ParseNumberSmaller}
                               className={`${errors.Pws_Ant_labo ? 'form-know-you-item-input-smaller display-flex input-error' : 'form-know-you-item-input-smaller display-flex'}`}
                               placeholder={intl.formatMessage({id: "placeholder_labor_old"})}/> */}
                        <Field id={"Pws_Ant_labo"}
                            name={"Pws_Ant_labo"}
                            disabled={true}
                            className={`${errors.Pws_Ant_labo ? 'form-know-you-item-input-smaller display-flex input-error' : 'form-know-you-item-input-smaller display-flex'}`}
                            placeholder={intl.formatMessage({ id: "placeholder_labor_old" })} />
                        {/*  <div className="label-fields-peps-warning">
                            <ErrorMessage name="Pws_Ant_labo"/>
                        </div> */}
                    </div>
                </div>
                <div className="col">
                    <div
                        className={"label-fields-peps-mobile display-flex"}>{intl.formatMessage({ id: "placeholder_job_that_performs" })}</div>
                    <div className="display-flex">
                        <Field id={"Pws_Car_emp"}
                            name={"Pws_Car_emp"}
                            className={`${errors.Pws_Car_emp ? 'form-know-you-item-input-smaller display-flex input-error' : 'form-know-you-item-input-smaller display-flex'}`}
                            placeholder={intl.formatMessage({ id: "placeholder_job_that_performs" })} />
                    </div>
                </div>
                <div className="col">
                    <div
                        className={"label-fields-peps-mobile display-flex"}>{intl.formatMessage({ id: "placeholder_direct_boss" })}</div>
                    <div className="display-flex">
                        <Field id={"Pws_Nom_Jefedi"}
                            name={"Pws_Nom_Jefedi"}
                            className={`${errors.Pws_Nom_Jefedi ? 'form-know-you-item-input-xxs display-flex input-error' : 'form-know-you-item-input-xxs display-flex'}`}
                            placeholder={intl.formatMessage({ id: "placeholder_direct_boss" })} />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <div
                        className={"label-fields-peps-mobile display-flex"}>{intl.formatMessage({ id: "placeholder_company_address" })}</div>
                    <div className="display-flex">
                        <Field id={"Pws_Direc_emp"}
                            name={"Pws_Direc_emp"}
                            className={`${errors.Pws_Direc_emp ? 'form-know-you-item-input-smaller display-flex input-error' : 'form-know-you-item-input-smaller display-flex'}`}
                            placeholder={intl.formatMessage({ id: "placeholder_company_address" })} />
                    </div>
                </div>
                <div className="col">
                    <div
                        className={"label-fields-peps-mobile display-flex"}>{intl.formatMessage({ id: "form_financial_city_foreign_currency" })}</div>
                    <div className="display-flex">
                        <Field as="select"
                            className={`${errors.Pws_Ciud_emp ? 'form-know-you-item-input-smaller display-flex input-error' : 'form-know-you-item-input-smaller display-flex'}`}
                            name="Pws_Ciud_emp"
                        >
                            <option>{intl.formatMessage({ id: "form_financial_city_foreign_currency" })}</option>
                            {ciudades && ciudades.ListCiudad.Datos_Ciudad.map((item: { s_codigo: string | number | readonly string[] | undefined; s_nombre: string | number | boolean | ReactElement<any, string | JSXElementConstructor<any>> | ReactFragment | ReactPortal | null | undefined; }, key: number) => {
                                return (
                                    <option key={key} value={item.s_codigo}>{item.s_nombre}</option>
                                )
                            })}
                        </Field>
                    </div>
                </div>
                <div className="col">
                    <div
                        className={"label-fields-peps-mobile display-flex"}>{intl.formatMessage({ id: "placeholder_phone_1" })}</div>
                    <div className="display-flex">
                        <Field id={"Pws_tel_emp1"}
                            name={"Pws_tel_emp1"}
                            onChange={handleOnlyNumbers}
                            className={`${errors.Pws_tel_emp1 ? 'form-know-you-item-input-smaller display-flex input-error' : 'form-know-you-item-input-smaller display-flex'}`}
                            placeholder={intl.formatMessage({ id: "placeholder_phone_1" })} />
                    </div>
                </div>
                <div className="col">
                    <div
                        className={"label-fields-peps-mobile display-flex"}>{intl.formatMessage({ id: "placeholder_phone_2" })}</div>
                    <div className="display-flex">
                        <Field id={"Pws_tel_emp2"}
                            name={"Pws_tel_emp2"}
                            onChange={handleOnlyNumbers}
                            className={`${errors.Pws_tel_emp2 ? 'form-know-you-item-input-smaller display-flex input-error' : 'form-know-you-item-input-smaller display-flex'}`}
                            placeholder={intl.formatMessage({ id: "placeholder_phone_2" })} />
                    </div>
                </div>
                <div className="col" />
                <div className="col" />
            </div>
        </div>
    )
}